import React from 'react';
import styles from './styles.module.scss';
import { ProductType } from '../../types';
import {
  generateSavingsSummary,
  getSummaryDisplayValue,
  SavingsSummaryItem,
} from '../../config/savingsConfig';

interface SavingsSummaryProps {
  productType: ProductType;
  zipFlag: boolean | null;
  zipCode?: string;
}

const renderRow = (item: SavingsSummaryItem, key: string) => (
  <div key={key} className={styles.savingsItem}>
    <span className={styles.itemLabel}>{item.label}</span>
    <span className={styles.itemValue}>{getSummaryDisplayValue(item.label, item.value)}</span>
  </div>
);

/**
 * Riepilogo incentivi nella slide di successo.
 * In testa: titolo "Stima risparmio in 10 anni:".
 * Bolletta e rivendita restano mascherati con "*** €".
 * Risparmio totale evidenziato con "Scoprilo in chiamata".
 */
const SavingsSummary: React.FC<SavingsSummaryProps> = ({
  productType,
  zipFlag,
  zipCode,
}) => {
  const summary = generateSavingsSummary(productType, zipFlag, zipCode);

  const isCombo = productType === 'Photovoltaic + Heatpump';
  const pvItems = isCombo ? summary.items.filter((item) => item.category === 'PV') : [];
  const hpItems = isCombo ? summary.items.filter((item) => item.category === 'HP') : [];
  const uncategorizedItems = isCombo
    ? summary.items.filter((item) => !item.category)
    : summary.items;

  return (
    <div className={styles.savingsSummaryBox}>
      <p className={styles.summaryTitle}>Stima risparmio in 10 anni:</p>

      {isCombo && pvItems.length > 0 && (
        <>
          <div className={styles.categoryDivider}>FOTOVOLTAICO</div>
          {pvItems.map((item, index) => renderRow(item, `pv-${index}`))}
        </>
      )}

      {isCombo && hpItems.length > 0 && (
        <>
          <div className={styles.categoryDivider}>POMPA DI CALORE</div>
          {hpItems.map((item, index) => renderRow(item, `hp-${index}`))}
        </>
      )}

      {uncategorizedItems.map((item, index) => renderRow(item, String(index)))}

      <div className={styles.savingsSeparator} />

      <div className={styles.savingsTotal}>
        <span className={styles.itemLabel}>Risparmio Totale</span>
        <span className={styles.totalCallout}>{summary.co2Saved}</span>
      </div>
    </div>
  );
};

export default SavingsSummary;
